'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

define(['app'], function (app) {

  // pure functions that don't rely on component variables
  var resetStyle = function resetStyle(el, sname) {
    return el.style[sname] = '';
  };
  var setStyle = function setStyle(el, sname, val) {
    return el.style[sname] = val;
  };
  var getStyle = function getStyle(el, sname) {
    return el.style[sname];
  };

  var getCssHeight = function getCssHeight(el) {
    return parseInt(getStyle(el, 'height'));
  };
  var setCssHeight = function setCssHeight(el, val) {
    return setStyle(el, 'height', val + 'px');
  };
  var resetCssHeight = function resetCssHeight(el) {
    return resetStyle(el, 'height');
  };

  var hide = function hide(el) {
    return el.classList.add('hide');
  };
  var show = function show(el) {
    return el.classList.remove('hide');
  };

  var getRenderedHeight = function getRenderedHeight(el) {
    return el.offsetHeight;
  };

  var readmore = function readmore() {
    var component = {};
    component.app = app;

    component.computed = {
      get collapsedHeight() {
        return getRenderedHeight(component.children.footer) + component.props.contentMaxHeight;
      },
      get expandedHeight() {
        return getRenderedHeight(component.children.content) + getRenderedHeight(component.children.footer);
      },
      get isCollapsed() {
        return getCssHeight(component.element) === component.computed.collapsedHeight;
      },
      get isTrimNeeded() {
        return getRenderedHeight(component.children.content) > component.props.contentMaxHeight + getRenderedHeight(component.children.footer);
      }
    };

    var _config = {
      props: {
        contentMaxHeight: {
          selector: 'data-max-height',
          defaultValue: 50,
          transform: function transform(n) {
            return parseInt(n);
          }
        },
        readMoreText: {
          selector: 'data-read-more-text',
          defaultValue: 'Read More'
        },
        readLessText: {
          selector: 'data-read-less-text',
          defaultValue: 'Read Less'
        }
      },
      children: {
        content: '.readmore_content',
        footer: '.readmore_footer',
        footerButton: '.readmore_footerButton'
      }
    };

    var _init = function _init(element) {
      component.element = element;

      component.children = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(component.config.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = _slicedToArray(_ref, 2);

          var childrenName = _ref2[0];
          var childrenSelector = _ref2[1];

          component.children[childrenName] = element.querySelector(childrenSelector);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      component.props = {};
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.entries(component.config.props)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref3 = _step2.value;

          var _ref4 = _slicedToArray(_ref3, 2);

          var propName = _ref4[0];
          var _ref4$ = _ref4[1];
          var selector = _ref4$.selector;
          var defaultValue = _ref4$.defaultValue;
          var _ref4$$transform = _ref4$.transform;
          var transform = _ref4$$transform === undefined ? function (x) {
            return x;
          } : _ref4$$transform;

          component.props[propName] = transform(app.element.getAttribute(selector, component.element) || defaultValue);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (component.computed.isTrimNeeded) {
        show(component.children.footer);
        component.attachListeners();
        component.collapse();
      } else {
        hide(component.children.footer);
        resetCssHeight(component.element);
      }

      return component;
    };

    var _attachListeners = function _attachListeners() {
      component.children.footerButton.addEventListener('click', component.toggle);
    };

    var _toggle = function _toggle() {
      return component.computed.isCollapsed ? component.expand() : component.collapse();
    };

    var _collapse = function _collapse() {
      component.children.footerButton.innerHTML = component.props.readMoreText;
      component.children.footerButton.setAttribute('aria-expanded', 'false');
      setCssHeight(component.element, component.computed.collapsedHeight);
    };

    var _expand = function _expand() {
      component.children.footerButton.innerHTML = component.props.readLessText;
      component.children.footerButton.setAttribute('aria-expanded', 'true');
      setCssHeight(component.element, component.computed.expandedHeight);
    };

    component.config = _config;
    component.init = _init;
    component.attachListeners = _attachListeners;
    component.toggle = _toggle;
    component.collapse = _collapse;
    component.expand = _expand;

    return component;
  };

  return readmore;
});
//# sourceMappingURL=readmore.js.map
